<main class="container-fluid">
  <app-admin-sidebar></app-admin-sidebar>
  <div class="organizations-container gap-3">
    <div class="w-100" *ngIf="user">
      <h1 class="subtitle">Organisatieoverzicht</h1>
      <h3 class="gray-text">In onderstaande tabel kun je de organisaties van de website beheren.</h3>
      <div class="input-group input-shadow my-3">
        <div class="input-group-prepend">
          <span class="input-group-text search-icon"><i class="bi bi-search"></i></span>
        </div>
        <input type="text" class="form-control search-input shadow-none" placeholder="Zoek op naam, e-mailadres of contactpersoon"  [(ngModel)]="searchTerm">
      </div>
      <div class="table-container input-shadow mt-3">
        <table class="organization-details">
          <thead>
          <tr>
            <td>Naam</td>
            <td>E-mail</td>
            <td>Adres</td>
            <td>Contactpersoon</td>
            <td>Status</td>
            <td>Aanmaakdatum</td>
            <td></td>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let retrievedOrg of nameFilter(organizations)">
            <td>{{ retrievedOrg.name }}</td>
            <td class="gray-text">{{ retrievedOrg.email }}</td>
            <td class="gray-text">{{ retrievedOrg.address }}</td>
            <td class="gray-text">{{ retrievedOrg.contactName }}</td>
            <td class="gray-text">{{ retrievedOrg.active ? "Actief" : "Inactief" }}</td>
            <td class="gray-text">{{ retrievedOrg.created }}</td>
            <td (click)="navigateToOrgProfile(retrievedOrg.id)"><i class="bi bi-chevron-right"></i></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</main>



